<div class="col-x1">
<div class="card">
  <div class="card-header" [style.background]="abierto.colorTitulo">

    <div class="row">
      <div class="col-sm-12 col-md-11">
        <h4 class="card-title">Incidencia No.<b>{{abierto.id}} -- {{abierto.nombre}}</b></h4>
      </div>
      <div class="col-sm-12 col-md-1">
        <button mat-icon-button (click)="onCloseClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
   </div>
 

  <div class="card-body">
    <div class="row">
      <div class="col-md-5">
        <div class="card card-stats">
          <div class="card-header card-header-success card-header-icon">
            <p class="card-category"> Proyecto</p>
            <h3 class="card-title">
              <small><b>{{abierto.nombre}}</b></small>
            </h3>
          </div>
          <div class="row card-text">
            <div class="col-5">
              <span class="btn-sm">
                <p class="btn btn-success estatus" [style.background]="abierto.colorTitulo"> Estatus:{{abierto.titulo}}</p>
              </span> 
            </div>
            <div class="col-5">
              <span class="btn-sm">
                <p class="btn btn-success" [style.background]="abierto.color"> Prioridad:{{abierto.BTP}} </p> 
              </span>
            </div>
          </div>
          </div>
          <mat-drawer-container>
            <table class="table">
              <thead class="cdk-visually-hidden"><tr><th scope="col">Datos de la incidencia</th></tr></thead>
              <tr>
                <td class="card-text" name="">Creado por: <b>Jaime Emmanuel Castorela Guzman</b></td>
              </tr>
  
              <tr>
                <td class="card-text" name="">Fecha de creación: <b>{{abierto.fechaI}}</b></td>
              </tr>
  
              <tr>
                <td class="card-text" name="">Fecha de actualización <b>{{abierto.fechaF}}</b></td>
              </tr>
            </table>

            <mat-form-field appearance="outline">
              <mat-label><b>Descripción</b></mat-label>
              <textarea readonly [ngModel]="abierto.descripcion" maxlength="2000" class="border" matInput aria-label="Descripción" rows="8" cols="50" style="background: #cecece45;">
              </textarea>
            </mat-form-field>

            <mat-radio-group aria-label="Select an option">
              <mat-radio-button vale="1" (click)="drawer.toggle()" (keydown.enter)="$event.target === $event.currentTarget ? drawer.toggle() : null">Asignar</mat-radio-button>
              <span  (click)="verHistorial()" (keydown.enter)="verHistorial()" class="material-icons" style="color: green; font-size: 18px; margin-left: 17px; padding: 0%; margin-top: 5px;"
              matTooltip="Historial de asignaciones" [matTooltipPosition]="'above'">ballot</span>
            <label style="margin-left: 1px; padding: 0%;">0</label>
            </mat-radio-group>
  

            <mat-drawer #drawer class="drawer"  mode="side">
                     
              <mat-form-field class="example-full-width" appearance="outline" >
                <mat-label>Asignado actual: </mat-label>
                <input readonly matInput aria-label="Asignado actual:" >
              </mat-form-field>
              

              <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Asignar a:</mat-label>
              
              <mat-select >
                                        <mat-option> Jaime Emmanuel Castorela Guzmán
                                            </mat-option>
              </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label><b> Motivo </b></mat-label>
                <textarea  maxlength="2000" class="border" matInput aria-label="Motivo" rows="8" cols="25" style="background: #cecece45">
                </textarea>                    
              </mat-form-field>

              <button class="btn btn-success" (click)="guardaAsignado()">
                <span class="btn-label">
                  <i class="material-icons">save</i>
                </span>
                Guardar
              <div class="ripple-container"></div></button>

            </mat-drawer>




            
          </mat-drawer-container>
        </div>

        <div class="col-md-7 card-group">
          <div class="card card-body-background">

            <div class="card-header card-header-tabs card-header-primary">
              <div class="nav-tabs-navigation">
                <div class="nav-tabs-wrapper">
                  <span class="nav-tabs-title">Operaciones : </span>
                  <ul class="nav nav-tabs" data-tabs="tabs">
                    <li class="nav-item"  style="cursor: pointer;">
                      <a class="nav-link"  data-toggle="tab" (click)="agregaComentario()">
                        <i class="material-icons">chat</i>Agregar
                        <div class="ripple-container"></div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="card-body" style="height: 450px; overflow: scroll;">
            <div class="card">

              <div class="card-header card card-header-warning">
                <h4 class="card-title">Descripción de incidencias</h4>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <mat-divider class="mat-divider"></mat-divider>
                    <div class="row">
                      <div class="col-auto mr-auto">
                        <span>
                          <i class="fa fa fa-user-circle-o fa-lg text-primary"></i>
                         <strong>Comentado por:</strong> Jaime Emmanuel Castorela Guzman
                        </span>
                      </div>
                    </div>

                    <div class="row ">
                      <div class="col-auto mr-auto">
                            <span><i class="fa fa fa-calendar fa-lg text-success" ></i>
                                
                                  <strong> Fecha:  {{abierto.fechaF}} </strong>
                                        
                            </span>
                      </div>
                </div>

                <div class="row ">
                  <div class="col-auto mr-auto">
                        <span>
                              <i class="fa fa fa-calendar-o fa-lg text-danger"></i>
                              <strong> Detectado en Version:{{abierto.version}} </strong>    
                            
                        </span>
                  </div>
            </div>

            <mat-divider class="mat-divider" [vertical]="true"></mat-divider>
                  </div>

                  <div class="col-md-6">

                  </div>
                  <mat-divider class="mat-divider"></mat-divider>
                  <div class="row ">
                    
                      <mat-divider  class="mat-divider" [vertical]="true"></mat-divider>
                      <!-- <mat-selection-list  style="max-height: 165px; overflow: auto;" >
                          <mat-list-item >
                           <p class="text-muted" matLine>  </p>
                           <a class="btn btn-secondary " style=" padding: 3px 5px ; " (click)="consultaImagenEvidencia(evidencias)" ><i class="material-icons ">visibility</i></a>
                           <a #downloadFile></a>
                           <button class="btn btn-secondary" style="padding: 3px 5px" 
                           (click)="descargaEvidencia(evidencias)">
                             <span><i class="material-icons ">cloud_download</i></span>
                           </button>
                         </mat-list-item>
                      </mat-selection-list> -->
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
        </div>
      </div>  
    </div>
  </div>
</div>